<commesse>
    <div class="bg-white rounded-lg p-8 mt-5">
        <div class="flex justify-between">
            <h2 class="text-2xl/8 font-bold text-custom sm:truncate sm:text-3xl sm:tracking-tight">Commesse</h2>
            <div class="filters">
                <form class="flex gap-4 items-center" method="POST" onsubmit="{
                            filter
                        }">
                    <combobox label="" ckey="filtro_societa" placeholder="Filtra per società..."></combobox>
                    <combobox label="" ckey="filtro_risorsa" placeholder="Filtra per risorsa..."></combobox>
                    <combobox label="" ckey="filtro_stato" placeholder="Filtra per stato..."></combobox>
                    <input-text ckey="search_text" placeholder="Cerca..."></input-text>
                    <my-button type="submit" is_square="1">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                            <path stroke-linecap="round" stroke-linejoin="round" d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
                        </svg>
                    </my-button>
                </form>
            </div>
        </div>
        <generic-table 
            ckey="{ KEYS.COMMESSE }" 
            columns="{ state.columns }"
            rows="{ state.rows }"
            total_rows="{ state.total_rows }"
            page_size="{ state.page_size }"
            current_page="{ state.current_page }"
            condensed="1" 
            >
            <span slot="actions"></span>
        </generic-table>
    </div>

    <script>
        import StoreService from '/src/services/store'
        import eventBus from '/src/utils/event-bus'
        import { fetchComboboxRisorse, fetchComboboxStati, fetchComboboxSocieta } from '/src/utils/functions'
        import moment from 'moment-with-locales-es6'
        import { CONFIG, EVENTS, KEYS, ACTIONS } from '/src/utils/constants'

        export default {

            ACTIONS: ACTIONS,
            KEYS: KEYS,

            onBeforeMount(props, state) {
                this.state = {
                    columns: [
                        {type: CONFIG.TEXT, label: 'Commessa n°', field: 'numero', is_sortable: true, is_link: true, link_prefix: '#/commesse', key_field: 'id_commessa'},
                        {type: CONFIG.TEXT, label: 'Società', field: 'societa', is_sortable: true},
                        {type: CONFIG.TEXT, label: 'Stato', field: 'stato', is_sortable: true},
                        {type: CONFIG.DATE, label: 'Data limite', field: 'data', is_sortable: true},
                        {type: CONFIG.TEXT, label: 'Cliente', field: 'cliente', is_sortable: true},
                        {type: CONFIG.TEXT, label: 'Titolo', field: 'titolo', is_wrappable: true},
                        {type: CONFIG.TEXT, label: 'Descrizione', field: 'descrizione', is_wrappable: true},
                        {type: CONFIG.TEXT, label: 'Risorse', field: 'risorsa'},
                    ],
                    rows: [],
                    total_rows: 0,
                    current_page: 1,
                    page_size: CONFIG.N_ITEMS,
                    sort_column: 'numero',
                    sort_direction: 'desc',
                    search_risorsa: '',
                    search_stato: '',
                    search_societa: '',
                    search_text: '',
                }
                //eventBus.on(EVENTS.COMBOBOX.SELECTED, this.handleComboboxSelected)
                eventBus.on(EVENTS.UI.CHANGE_PAGE, this.handlePageChange)
                eventBus.on(EVENTS.UI.SORTING_CHANGE, this.handleSortChange)
                eventBus.on(EVENTS.UI.CLICK_BUTTON_GROUP, this.handleClickAction)
                eventBus.on(EVENTS.ITEMS.REFRESH, this.handleRefresh)
            },

            async onMounted(props, state) {
                fetchComboboxRisorse().then(risorse => {
                    eventBus.trigger(EVENTS.COMBOBOX.UPDATE, {
                        ckey: 'filtro_risorsa',
                        items: risorse
                    });
                });
                fetchComboboxStati().then(stati => {
                    eventBus.trigger(EVENTS.COMBOBOX.UPDATE, {
                        ckey: 'filtro_stato',
                        items: stati
                    });
                });

                fetchComboboxSocieta().then(societa => {
                    eventBus.trigger(EVENTS.COMBOBOX.UPDATE, {
                        ckey: 'filtro_societa',
                        items: societa
                    });
                });
                this.fetchData()
            },

            onBeforeUnmount(props, state) {
                //eventBus.off(EVENTS.COMBOBOX.SELECTED, this.handleComboboxSelected)
                eventBus.off(EVENTS.UI.CHANGE_PAGE, this.handlePageChange)
                eventBus.off(EVENTS.UI.SORTING_CHANGE, this.handleSortChange)
                eventBus.off(EVENTS.UI.CLICK_BUTTON_GROUP, this.handleClickAction)
                eventBus.off(EVENTS.ITEMS.REFRESH, this.handleRefresh)
            },

            /*
             handleComboboxSelected(e) {
             switch (e.ckey) {
             case 'filtro_stato':
             this.update({
             search_stato: e.value
             })
             break
             case 'filtro_risorsa':
             this.update({
             search_risorsa: e.value
             })
             break
             }
             },
             */

            handleRefresh(e) {
                if (e.ckey === KEYS.COMMESSE) {
                    this.fetchData();
                }
            },

            handleClickAction(e) {
                if (e.ckey === KEYS.COMMESSE) {
                    switch (e.action) {
                        case ACTIONS.EDIT:
                            //eventBus.trigger(EVENTS.UI.OPEN_MODAL_COMMESSEO, {
                            //    ckey: KEYS.COMMESSE,
                            //    data: e.data
                            //})
                            break
                    }
                }
            },

            handlePageChange(e) {
                if (e.ckey === KEYS.COMMESSE) {
                    this.update({current_page: e.page});
                    this.fetchData();
                }
            },

            handleSortChange(e) {
                if (e.ckey === KEYS.COMMESSE) {
                    this.update({
                        sort_column: e.column,
                        sort_direction: e.direction,
                        current_page: 1 // Torna alla prima pagina
                    });
                    this.fetchData();
                }
            },

            async fetchData() {
                const {sort_column, sort_direction, current_page, search_risorsa, search_stato, search_societa, search_text} = this.state;
                const where = {};
                if (search_risorsa) {
                    where.risorsa = search_risorsa
                }
                if (search_stato) {
                    where.stato = search_stato
                }
                if (search_societa) {
                    where.societa = search_societa
                }
                const result = await StoreService.fetchCommesse(
                        sort_column,
                        sort_direction,
                        current_page,
                        search_text,
                        where
                        );
                if (result.items) {
                    this.update({
                        rows: result.items,
                        total_rows: result.total
                    })
                    eventBus.trigger(EVENTS.ITEMS.CHANGED, {
                        ckey: KEYS.COMMESSE,
                        items: {
                            count: this.state.total_rows,
                            results: this.state.rows
                        },
                        page: this.state.current_page
                    })
                } else {
                    console.error('Errore nel caricamento dei dati:', result.error)
                }
            },

            filter(e) {
                e.preventDefault(); // Evita il refresh della pagina
                const filtroRisorsa = document.getElementById('filtro_risorsa')?.value || '';
                const filtroStato = document.getElementById('filtro_stato')?.value || '';
                const filtroSocieta = document.getElementById('filtro_societa')?.value || '';
                const searchText = document.getElementById('search_text')?.value || '';
                // Aggiorna lo stato con i filtri attivi
                this.update({
                    search_risorsa: filtroRisorsa,
                    search_stato: filtroStato,
                    search_societa: filtroSocieta,
                    search_text: searchText,
                    current_page: 1 // Reset alla prima pagina
                });
                // Effettua una nuova query
                this.fetchData();
            },
        }

    </script>
</commesse>
